import GenericCrudPage from "./GenericCrudPage";

const CATEGORY = [
  { value: "material", label: "Material Supplier" },
  { value: "subcontractor", label: "Subcontractor" },
  { value: "machinery", label: "Machinery Supplier" },
  { value: "consultant", label: "Consultant" },
];

export default function VendorsPage() {
  return (
    <GenericCrudPage
      testid="vendors"
      overline="PROCUREMENT"
      title="Vendors"
      description="Suppliers, subcontractors and consultants. Vendor agreements are stored in Documents."
      endpoint="/vendors"
      defaults={{ name: "", contact_person: "", phone: "", email: "", category: "material", gst_number: "", address: "" }}
      fields={[
        { name: "name", label: "Vendor Name", type: "text", colSpan: 2 },
        { name: "category", label: "Category", type: "select", options: CATEGORY },
        { name: "gst_number", label: "GST Number", type: "text" },
        { name: "contact_person", label: "Contact Person", type: "text" },
        { name: "phone", label: "Phone", type: "text" },
        { name: "email", label: "Email", type: "text", colSpan: 2 },
        { name: "address", label: "Address", type: "textarea", colSpan: 2 },
      ]}
      columns={["name", "category", "contact_person", "phone", "gst_number"]}
    />
  );
}
